export const CApplicationID =
{
    CCT: "444c94ac-fdb6-4d3f-9992-7c1abfbc48ac",
    CTC: "9b697193-ded3-4716-9666-f2d24f5ae7f8",
    SSO: "1231323-ded3-4716-9666-f2d24f5ae7f8",
    REPORT: "555594ac-fdb6-4d3f-9992-7c1abfbc48ac",
    OPF:"09696ba5-f07e-4952-b2c8-0bf9bb722f66"
}
export const CAPPNames = {
    CCT: "CCT",
    CTC: "CTC",
    SSO:"SSO",
    REPORT: "REPORT",
    OPF:"OPF"
}
export const CPartnerType = {
    CTC_PARTNER_ACQ: "CTC_ACQUIRER_MERCHANT",
    ACQURIER_MERCHANT: "CCT_ACQUIRER_MERCHANT",
    DISCOVER: "CCT_DISCOVER",
    NET_TO_NET: "CCT_NET_TO_NET",
    SERVICE_PROVIDER: "CCT_SERVICE_PROVIDER",
    TEST_LAB: "CCT_TEST_LAB",
    N2N_ACQUIRER_MERCHANT: "CCT_N2N_ACQUIRER_MERCHANT",
    N2N_TEST_LAB: "CCT_N2N_TEST_LAB"
}